<!-- TEMPLATE -->
<template>
  <dean-dialog
          class="graph"
          title="Telefoniegebruikers totaal"
          :icon="offersIcon"
          align-top>
    <div class="">
      <column-chart :data="source" :colors="['#007992', '#007992']"></column-chart>
    </div>
    <transition name="fade" mode="out-in" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </dean-dialog>
</template>
<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';

  // DEAN COMPONENTS
  import {
    plusIcon,
    offersIcon,
    deanDialog,
    deanButton,
    deanLoadOverlay,
  } from '@deanone/dean-components';
  import Chartkick from 'vue-chartkick';
  import Chart from 'chart.js';
  import axios from 'axios';

  Vue.use(Chartkick.use(Chart));

  @Component({
    components: {
      deanLoadOverlay,
      Chartkick,
      Chart,
      plusIcon,
      offersIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class TelephoneUsersGraph extends Vue {
    public plusIcon: object = plusIcon;
    public offersIcon: object = offersIcon;
    public source: object = {};
    public isLoading: boolean = true;

    public mounted() {
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      axios
        .post('/-/trade/api/widgets.telephoneUsersGraph')
        .then(({data}) => {
          this.source = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dialog :deep {
    padding: 0;
  }

  .dialog :deep(.dean-dialog-container) {
    width: 100%;
    height: 100%;
  }

  .dialog :deep(.dean-dialog-container .dean-dialog-content) {
    height: 100%;
  }
</style>
